/**
 * FeedbackAnalyticsPage
 *
 * Page wrapper for Feedback Analytics.
 *
 * @module pages/dev/FeedbackAnalyticsPage
 */

import React from 'react';
import FeedbackAnalytics from '../../components/dev/FeedbackAnalytics';

/**
 * FeedbackAnalyticsPage
 */
const FeedbackAnalyticsPage: React.FC = () => {
  return <FeedbackAnalytics />;
};

export default FeedbackAnalyticsPage;
